import {apiClient} from "@leap4/frontend";

export const getObjectById = async (baseUrl, id) => {
    const response = await apiClient.get(`${baseUrl}/${id}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        }
    );
    return response.data
}

export const getObjectData = async (baseUrl, model) => {
    const response = await apiClient.get(baseUrl,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            params: model
        }
    );
    return response.data
}

export const postObjectData = async (baseUrl, model) => {
    const response = await apiClient.post(baseUrl, model,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        }
    );
    return response.data
}
